<script>

// Logic
import {getCovidArticles} from '../utils/apiNew';

// Bindings
$: articles = [];
let tempList = [];

getCovidArticles().then(res => {
    Object.values(res).forEach(item => {
        if(item.items != undefined) {
            let imgUrl = "";
            try {
                imgUrl = item.items[0].image.imageAsset.urls[4].url;
            } catch (error) {
                
            }
            tempList.push({
                title: item.items[0].title.value,
                imgUrl: imgUrl,
                link: item.items[0].target.expandedUri   
            })
        }
    })
}).finally(() => articles = tempList.splice(0,6))

</script>

<div class="articles container">
    <div class="columns article-gap">
        {#each articles as el}
        <div class="column col-6 article">
            <a class="article-link" href={el.link}>
                {#if el.imgUrl == ""}
                <div class="img-placeholder"></div>
                {:else}
                <img class="article-img" src={el.imgUrl} loading="lazy" alt=""/>
                {/if}
                <h3 class="article-title">{el.title}</h3>
            </a>
        </div>
        {/each}
    </div>
</div>


<style lang="scss">
.articles {
    margin-top: 1rem;
}

.article {
    padding: 0 .5rem 1rem;

.img-placeholder {
    padding-top: 57%;
    background-color: #ececec;
}
    &-img {
        width: 100%;
        height: auto;
    }
    &-title {
        margin: 0;
        margin-top: .2rem;
        font-weight: 500;
        //font-size: fontsize('std');
    }
}

</style>